import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/wave2.svg")